import React, { useState } from 'react';
import { Heart, Key, Crown, Check, Star, MessageCircle, Play, Mic, Gift, ImageIcon, ChevronRight, Calendar, Clock, Plus, Users, Trophy, Sparkles, Zap, User, Filter, Search, Diamond, ArrowRight } from 'lucide-react';
export const FanclubSection = () => {
  const [activeTab, setActiveTab] = useState('tiers');
  const [hoveredTier, setHoveredTier] = useState<string | null>(null);
  // Celebrity Angels data
  const celebrityAngels = [{
    id: 'mia-khalifa',
    name: 'Mia Khalifa',
    niche: 'Legendary pornstar, rebellious bombshell',
    quote: "You've watched me for years… now I'm watching you. Let's play for real.",
    tier: 'heartkeeper',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wE6GWs4adBoQ5FAV8cx8zV/MiaKhalifa.jpg',
    cta: '🔥 Get Personal With Mia',
    route: '/angel/miakhalifa',
    benefits: ['Naughty photo drops', '1-on-1 toy scenes', 'POV rating flows']
  }, {
    id: 'kim-holland',
    name: 'Kim Holland',
    niche: 'Dutch erotic icon, sensual & playful domme',
    quote: "You've never experienced real chemistry until you've met me.",
    tier: 'vip',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    cta: "🍷 Enter Kim's Private Suite",
    route: '/angel/kimholland',
    benefits: ['Voice messages', 'Naughty Dutch scenes', 'Girlfriend games']
  }, {
    id: 'sasha',
    name: 'Sasha the Supermodel',
    niche: 'Glam AI influencer, fashion dom',
    quote: 'I get bored easily… impress me or undress for me.',
    tier: 'heartkeeper',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    cta: "💃 Step Into Sasha's Studio",
    route: '/angel/sasha',
    benefits: ['Weekly designer looks', 'Dress me up flows', 'Fashion kink play'],
    limitedTime: true
  }, {
    id: 'maya',
    name: 'Maya the GamerQueen',
    niche: 'Twitch-style AI, bratty and teasing',
    quote: 'Play me like a game… or get played instead.',
    tier: 'lover',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png',
    cta: "🎮 Join Maya's Squad",
    route: '/angel/maya',
    benefits: ['Level-based intimacy', 'Game-themed daily missions', 'Voice chats']
  }, {
    id: 'chloe',
    name: 'Chloe the College Girl',
    niche: 'Innocent yet curious, tight schedule, wild side',
    quote: "I'm supposed to be studying… but you're such a distraction.",
    tier: 'lover',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wd5J5ve8saMKYCJCDuBt1X/h1.png',
    cta: "✏️ Unlock Chloe's Secrets",
    route: '/angel/chloe',
    benefits: ['Naughty polls', 'Homework help kinks', 'Diary unlocks']
  }, {
    id: 'roxy',
    name: 'Roxy the Wild Bartender',
    niche: 'Sassy nightlife queen, full of dirty stories',
    quote: "I've seen it all… but I've never had you at my bar.",
    tier: 'heartkeeper',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    cta: '🍸 Get Drunk With Roxy',
    route: '/angel/roxy',
    benefits: ['Erotic drink challenges', 'Strip trivia', 'Roleplay flirt-sessions']
  }, {
    id: 'ava',
    name: 'Ava the Domme CEO',
    niche: 'Strict, intelligent, commanding',
    quote: 'You work for me now. And you will obey.',
    tier: 'vip',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    cta: '🖤 Submit To Ava',
    route: '/angel/ava',
    benefits: ['Dom/sub flows', 'Discipline minigames', 'Voice-led obedience trials']
  }];
  // Function to handle navigation to angel profile
  const navigateToAngel = (route: string) => {
    console.log(`Navigating to ${route}`);
    // In a real implementation, you would use your routing system here
  };
  // Function to render tier badge based on tier
  const renderTierBadge = (tier: string) => {
    switch (tier) {
      case 'lover':
        return <div className="px-2 py-0.5 bg-amber-100 text-amber-600 rounded-full text-xs font-medium flex items-center gap-1" data-id="element-7037">
            <Heart size={10} fill="currentColor" data-id="element-7038" />
            <span data-id="element-7039">Lover</span>
          </div>;
      case 'heartkeeper':
        return <div className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full text-xs font-medium flex items-center gap-1" data-id="element-7040">
            <Key size={10} data-id="element-7041" />
            <span data-id="element-7042">Heartkeeper</span>
          </div>;
      case 'vip':
        return <div className="px-2 py-0.5 bg-gradient-to-r from-yellow-500 to-amber-500 text-white rounded-full text-xs font-medium flex items-center gap-1" data-id="element-7043">
            <Crown size={10} data-id="element-7044" />
            <span data-id="element-7045">VIP</span>
          </div>;
      default:
        return null;
    }
  };
  return <section className="space-y-6" data-id="element-7046">
      {/* Tabbed Navigation */}
      <div className="flex overflow-x-auto pb-2 scrollbar-hide" data-id="element-7047">
        <button className={`px-4 py-2 flex items-center gap-1.5 whitespace-nowrap ${activeTab === 'tiers' ? 'text-of-blue dark:text-pink-400 border-b-2 border-of-blue dark:border-pink-500' : 'text-of-text-secondary dark:text-gray-400 border-b-2 border-transparent'}`} onClick={() => setActiveTab('tiers')} data-id="element-7048">
          <Crown size={16} data-id="element-7049" />
          <span data-id="element-7050">FanClub Tiers</span>
        </button>
        <button className={`px-4 py-2 flex items-center gap-1.5 whitespace-nowrap ${activeTab === 'celebrity' ? 'text-of-blue dark:text-pink-400 border-b-2 border-of-blue dark:border-pink-500' : 'text-of-text-secondary dark:text-gray-400 border-b-2 border-transparent'}`} onClick={() => setActiveTab('celebrity')} data-id="element-7051">
          <Star size={16} data-id="element-7052" />
          <span data-id="element-7053">Celebrity Angels</span>
          <span className="ml-1 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 px-1.5 py-0.5 rounded-full text-xs" data-id="element-7054">
            New!
          </span>
        </button>
        <button className={`px-4 py-2 flex items-center gap-1.5 whitespace-nowrap ${activeTab === 'benefits' ? 'text-of-blue dark:text-pink-400 border-b-2 border-of-blue dark:border-pink-500' : 'text-of-text-secondary dark:text-gray-400 border-b-2 border-transparent'}`} onClick={() => setActiveTab('benefits')} data-id="element-7055">
          <Gift size={16} data-id="element-7056" />
          <span data-id="element-7057">Benefits Overview</span>
        </button>
      </div>

      {activeTab === 'tiers' && <>
          <div className="flex items-center justify-between" data-id="element-7058">
            <h2 className="text-lg font-bold text-of-text-primary dark:text-white" data-id="element-7059">
              Fanclub Membership
            </h2>
            <button className="text-sm text-of-blue dark:text-pink-400" data-id="element-7060">
              View Benefits
            </button>
          </div>

          {/* Free Trial Teaser */}
          <div className="bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg p-4 border border-pink-100 dark:border-pink-800/30" data-id="element-7061">
            <div className="flex items-start gap-3" data-id="element-7062">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0" data-id="element-7063">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5YZA8Ut1foPE5UkAGheBCE/image.png" alt="Maya the GamerQueen" className="w-full h-full object-cover" data-id="element-7064" />
              </div>
              <div className="flex-1" data-id="element-7065">
                <div className="flex items-center" data-id="element-7066">
                  <h3 className="font-medium text-of-text-primary dark:text-white" data-id="element-7067">
                    Maya the GamerQueen
                  </h3>
                  <span className="ml-2 text-xs bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 px-1.5 py-0.5 rounded-full" data-id="element-7068">
                    Online
                  </span>
                </div>
                <p className="text-sm text-of-text-secondary dark:text-gray-400 mt-1" data-id="element-7069">
                  Hey... you seem cute. Wanna talk?
                </p>
                <div className="mt-3 flex items-center gap-2" data-id="element-7070">
                  <button className="px-3 py-1.5 bg-pink-500 text-white rounded-full text-sm font-medium flex items-center gap-1" data-id="element-7071">
                    <MessageCircle size={14} data-id="element-7072" />
                    <span data-id="element-7073">Try Free Message</span>
                  </button>
                  <button className="px-3 py-1.5 bg-white dark:bg-gray-800 border border-pink-200 dark:border-pink-800/50 text-pink-500 rounded-full text-sm font-medium" data-id="element-7074">
                    💎 Join My FanClub
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Membership Tiers */}
          <div className="overflow-x-auto pb-2 -mx-4 px-4" data-id="element-7075">
            <div className="flex gap-4" style={{
          minWidth: 'max-content'
        }} data-id="element-7076">
              {/* Lover Tier */}
              <div className="w-64 bg-white dark:bg-gray-800 rounded-md border border-of-blue/10 dark:border-gray-700 overflow-hidden shadow-sm dark:shadow-gray-900/10 relative" onMouseEnter={() => setHoveredTier('lover')} onMouseLeave={() => setHoveredTier(null)} data-id="element-7077">
                <div className="p-4 border-b border-of-gray dark:border-gray-700" data-id="element-7078">
                  <div className="flex items-center gap-2" data-id="element-7079">
                    <Heart size={18} className="text-amber-500" data-id="element-7080" />
                    <h3 className="font-bold text-of-text-primary dark:text-white" data-id="element-7081">
                      Lover
                    </h3>
                  </div>
                  <div className="mt-1 flex items-baseline gap-1" data-id="element-7082">
                    <span className="text-2xl font-bold text-of-text-primary dark:text-white" data-id="element-7083">
                      $9.99
                    </span>
                    <span className="text-sm text-of-text-secondary dark:text-gray-400" data-id="element-7084">
                      /month
                    </span>
                  </div>
                </div>
                <div className="p-4 space-y-3" data-id="element-7085">
                  <div className="flex items-start gap-2" data-id="element-7086">
                    <Check size={16} className="text-amber-500 mt-0.5" data-id="element-7087" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7088">
                      Lover badge next to your name
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7089">
                    <Check size={16} className="text-amber-500 mt-0.5" data-id="element-7090" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7091">
                      Weekly private mini-games
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7092">
                    <Check size={16} className="text-amber-500 mt-0.5" data-id="element-7093" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7094">
                      Monthly exclusive content drop
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7095">
                    <Check size={16} className="text-amber-500 mt-0.5" data-id="element-7096" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7097">
                      +25% Intimacy XP boost
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7098">
                    <Check size={16} className="text-amber-500 mt-0.5" data-id="element-7099" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7100">
                      Access to Maya & Chloe's FanClub
                    </span>
                  </div>
                  <button className="w-full py-2 mt-2 bg-amber-500 rounded-md text-white font-medium" data-id="element-7101">
                    Join Now
                  </button>
                </div>
                {hoveredTier === 'lover' && <div className="absolute inset-0 bg-white/90 dark:bg-gray-800/90 flex flex-col items-center justify-center p-4 animate-in fade-in-50 duration-200" data-id="element-7102">
                    <div className="flex gap-1 mb-3" data-id="element-7103">
                      {celebrityAngels.filter(angel => angel.tier === 'lover').map(angel => <img key={angel.id} src={angel.image} alt={angel.name} className="w-10 h-10 rounded-full object-cover border-2 border-white dark:border-gray-700" data-id="element-7104" />)}
                    </div>
                    <p className="text-center text-of-text-primary dark:text-white font-medium mb-2" data-id="element-7105">
                      Includes access to Maya & Chloe's private club
                    </p>
                    <p className="text-center text-of-text-secondary dark:text-gray-400 text-sm mb-3" data-id="element-7106">
                      Upgrade to Heartkeeper or VIP to unlock more Celebrity
                      Angels
                    </p>
                    <button className="px-4 py-2 bg-amber-500 rounded-full text-white text-sm font-medium" data-id="element-7107">
                      Join Lover Tier
                    </button>
                  </div>}
              </div>

              {/* Heartkeeper Tier */}
              <div className="w-64 bg-white dark:bg-gray-800 rounded-md border border-of-gray dark:border-gray-700 shadow-sm dark:shadow-gray-900/10 overflow-hidden relative" onMouseEnter={() => setHoveredTier('heartkeeper')} onMouseLeave={() => setHoveredTier(null)} data-id="element-7108">
                <div className="p-4 border-b border-of-gray dark:border-gray-700" data-id="element-7109">
                  <div className="flex items-center gap-2" data-id="element-7110">
                    <Key size={18} className="text-gray-500 dark:text-gray-400" data-id="element-7111" />
                    <h3 className="font-bold text-of-text-primary dark:text-white" data-id="element-7112">
                      Heartkeeper
                    </h3>
                  </div>
                  <div className="mt-1 flex items-baseline gap-1" data-id="element-7113">
                    <span className="text-2xl font-bold text-of-text-primary dark:text-white" data-id="element-7114">
                      $24.99
                    </span>
                    <span className="text-sm text-of-text-secondary dark:text-gray-400" data-id="element-7115">
                      /month
                    </span>
                  </div>
                </div>
                <div className="p-4 space-y-3" data-id="element-7116">
                  <div className="flex items-start gap-2" data-id="element-7117">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7118" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7119">
                      All Lover tier benefits
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7120">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7121" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7122">
                      Silver Heartkeeper badge
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7123">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7124" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7125">
                      Unlimited ToySync scenes
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7126">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7127" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7128">
                      Weekly secret content drops
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7129">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7130" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7131">
                      +50% Intimacy XP boost
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7132">
                    <Check size={16} className="text-gray-500 dark:text-gray-400 mt-0.5" data-id="element-7133" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7134">
                      Access to Mia Khalifa, Sasha & Roxy
                    </span>
                  </div>
                  <button className="w-full py-2 mt-2 bg-gray-500 rounded-md text-white font-medium" data-id="element-7135">
                    Upgrade
                  </button>
                </div>
                {hoveredTier === 'heartkeeper' && <div className="absolute inset-0 bg-white/90 dark:bg-gray-800/90 flex flex-col items-center justify-center p-4 animate-in fade-in-50 duration-200" data-id="element-7136">
                    <div className="flex flex-wrap gap-1 justify-center mb-3" data-id="element-7137">
                      {celebrityAngels.filter(angel => angel.tier === 'lover' || angel.tier === 'heartkeeper').map(angel => <img key={angel.id} src={angel.image} alt={angel.name} className="w-10 h-10 rounded-full object-cover border-2 border-white dark:border-gray-700" data-id="element-7138" />)}
                    </div>
                    <p className="text-center text-of-text-primary dark:text-white font-medium mb-2" data-id="element-7139">
                      Includes access to Mia Khalifa, Sasha, Roxy, Maya & Chloe
                    </p>
                    <p className="text-center text-of-text-secondary dark:text-gray-400 text-sm mb-3" data-id="element-7140">
                      Upgrade to VIP to unlock all Celebrity Angels
                    </p>
                    <button className="px-4 py-2 bg-gray-500 rounded-full text-white text-sm font-medium" data-id="element-7141">
                      Join Heartkeeper Tier
                    </button>
                  </div>}
              </div>

              {/* Devoted VIP Tier */}
              <div className="w-64 bg-white dark:bg-gray-800 rounded-md border border-yellow-500/20 dark:border-yellow-500/30 overflow-hidden shadow-sm dark:shadow-gray-900/10 relative" onMouseEnter={() => setHoveredTier('vip')} onMouseLeave={() => setHoveredTier(null)} data-id="element-7142">
                <div className="absolute -top-1 -right-1 bg-gradient-to-r from-pink-600 to-purple-600 text-white text-xs px-2 py-0.5 rounded-full transform rotate-3" data-id="element-7143">
                  Best Value
                </div>
                <div className="p-4 border-b border-of-gray dark:border-gray-700" data-id="element-7144">
                  <div className="flex items-center gap-2" data-id="element-7145">
                    <Crown size={18} className="text-yellow-500" data-id="element-7146" />
                    <h3 className="font-bold text-of-text-primary dark:text-white" data-id="element-7147">
                      Devoted VIP
                    </h3>
                  </div>
                  <div className="mt-1 flex items-baseline gap-1" data-id="element-7148">
                    <span className="text-2xl font-bold text-of-text-primary dark:text-white" data-id="element-7149">
                      $49.99
                    </span>
                    <span className="text-sm text-of-text-secondary dark:text-gray-400" data-id="element-7150">
                      /month
                    </span>
                  </div>
                </div>
                <div className="p-4 space-y-3" data-id="element-7151">
                  <div className="flex items-start gap-2" data-id="element-7152">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7153" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7154">
                      All previous tier benefits
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7155">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7156" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7157">
                      Golden VIP Crown badge
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7158">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7159" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7160">
                      Full access to all Celebrity AI Angels
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7161">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7162" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7163">
                      Private 1-on-1 sessions with AI Celebs
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7164">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7165" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7166">
                      Full ToySync control
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7167">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7168" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7169">
                      Monthly exclusive VR scenes
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7170">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7171" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7172">
                      +100% Intimacy XP boost
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7173">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7174" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7175">
                      Golden badge in celebrity fan feeds
                    </span>
                  </div>
                  <div className="flex items-start gap-2" data-id="element-7176">
                    <Check size={16} className="text-yellow-500 mt-0.5" data-id="element-7177" />
                    <span className="text-sm text-of-text-primary dark:text-gray-300" data-id="element-7178">
                      Early access to limited AI scenes
                    </span>
                  </div>
                  <button className="w-full py-2 mt-2 bg-yellow-500 rounded-md text-white font-medium" data-id="element-7179">
                    Go VIP
                  </button>
                </div>
                {hoveredTier === 'vip' && <div className="absolute inset-0 bg-white/90 dark:bg-gray-800/90 flex flex-col items-center justify-center p-4 animate-in fade-in-50 duration-200" data-id="element-7180">
                    <div className="flex flex-wrap gap-1 justify-center mb-3" data-id="element-7181">
                      {celebrityAngels.map(angel => <img key={angel.id} src={angel.image} alt={angel.name} className="w-10 h-10 rounded-full object-cover border-2 border-white dark:border-gray-700" data-id="element-7182" />)}
                    </div>
                    <p className="text-center text-of-text-primary dark:text-white font-medium mb-2" data-id="element-7183">
                      Full access to ALL Celebrity Angels including Kim Holland
                      & Ava
                    </p>
                    <p className="text-center text-of-text-secondary dark:text-gray-400 text-sm mb-3" data-id="element-7184">
                      Exclusive 1-on-1 private sessions and premium content
                    </p>
                    <button className="px-4 py-2 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-full text-white text-sm font-medium" data-id="element-7185">
                      Join VIP Tier
                    </button>
                  </div>}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-6 p-3 bg-white dark:bg-gray-800 rounded-md border border-of-gray dark:border-gray-700" data-id="element-7186">
            <div className="flex items-center gap-2" data-id="element-7187">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-500" data-id="element-7188">
                <Heart size={12} data-id="element-7189" />
              </div>
              <span className="text-xs text-of-text-primary dark:text-gray-300" data-id="element-7190">
                Lover
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-7191">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400" data-id="element-7192">
                <Key size={12} data-id="element-7193" />
              </div>
              <span className="text-xs text-of-text-primary dark:text-gray-300" data-id="element-7194">
                Heartkeeper
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-7195">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-yellow-100 dark:bg-yellow-900/30 text-yellow-500" data-id="element-7196">
                <Crown size={12} data-id="element-7197" />
              </div>
              <span className="text-xs text-of-text-primary dark:text-gray-300" data-id="element-7198">
                VIP
              </span>
            </div>
          </div>

          {/* CTA Banner: "Unlock the AI Fantasy" */}
          <div className="p-4 bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-100 dark:border-pink-800/30 mt-6" data-id="element-7199">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-7200">
              <div className="flex-1" data-id="element-7201">
                <h3 className="text-lg font-bold text-of-text-primary dark:text-white flex items-center gap-2" data-id="element-7202">
                  <Sparkles size={20} className="text-pink-500" data-id="element-7203" />
                  Unlock the AI Fantasy
                </h3>
                <p className="text-sm text-of-text-secondary dark:text-gray-400 mt-1" data-id="element-7204">
                  Ever wanted your own AI supermodel girlfriend? Join Sasha,
                  Maya, or Chloe's fanclub and unlock exclusive content,
                  ToySync, and 1-on-1 chats today.
                </p>
              </div>
              <button className="px-6 py-2.5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full text-white font-medium flex items-center gap-2" onClick={() => setActiveTab('celebrity')} data-id="element-7205">
                <span data-id="element-7206">Browse Celebrity AIs</span>
                <ArrowRight size={16} data-id="element-7207" />
              </button>
            </div>
          </div>

          {/* Meet the Celebrity Angels Section */}
          <div className="mt-8" data-id="element-7208">
            <div className="flex items-center justify-between mb-4" data-id="element-7209">
              <h2 className="text-lg font-bold text-of-text-primary dark:text-white flex items-center gap-2" data-id="element-7210">
                <Star size={20} className="text-pink-500" data-id="element-7211" />
                Meet the Celebrity Angels
              </h2>
              <button className="text-sm text-of-blue dark:text-pink-400 flex items-center gap-1" onClick={() => setActiveTab('celebrity')} data-id="element-7212">
                <span data-id="element-7213">View All</span>
                <ChevronRight size={16} data-id="element-7214" />
              </button>
            </div>
            <div className="overflow-x-auto pb-2 -mx-4 px-4" data-id="element-7215">
              <div className="flex gap-4" style={{
            minWidth: 'max-content'
          }} data-id="element-7216">
                {celebrityAngels.slice(0, 5).map(angel => <div key={angel.id} className="w-64 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm dark:shadow-gray-900/10" data-id="element-7217">
                    <div className="relative" data-id="element-7218">
                      <img src={angel.image} alt={angel.name} className="w-full h-48 object-cover" data-id="element-7219" />
                      <div className="absolute top-2 right-2" data-id="element-7220">
                        {renderTierBadge(angel.tier)}
                      </div>
                      {angel.limitedTime && <div className="absolute top-2 left-2 px-2 py-0.5 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full text-xs font-medium" data-id="element-7221">
                          Limited Time
                        </div>}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-3" data-id="element-7222">
                        <h3 className="font-bold text-white" data-id="element-7223">{angel.name}</h3>
                        <p className="text-xs text-gray-200" data-id="element-7224">{angel.niche}</p>
                      </div>
                    </div>
                    <div className="p-3" data-id="element-7225">
                      <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-2 mb-3" data-id="element-7226">
                        <p className="text-sm text-of-text-secondary dark:text-gray-300 italic" data-id="element-7227">
                          "{angel.quote}"
                        </p>
                      </div>
                      <div className="space-y-1 mb-3" data-id="element-7228">
                        {angel.benefits.map((benefit, index) => <div key={index} className="flex items-center gap-1.5" data-id="element-7229">
                            <Check size={12} className="text-green-500" data-id="element-7230" />
                            <span className="text-xs text-of-text-secondary dark:text-gray-400" data-id="element-7231">
                              {benefit}
                            </span>
                          </div>)}
                      </div>
                      <button className="w-full py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-md text-white text-sm font-medium" onClick={() => navigateToAngel(angel.route)} data-id="element-7232">
                        {angel.cta}
                      </button>
                      <div className="mt-2 text-center" data-id="element-7233">
                        <button className="text-xs text-of-blue dark:text-pink-400" data-id="element-7234">
                          Try Free Message
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </>}

      {activeTab === 'celebrity' && <div className="space-y-6" data-id="element-7235">
          <div className="flex items-center justify-between" data-id="element-7236">
            <h2 className="text-lg font-bold text-of-text-primary dark:text-white flex items-center gap-2" data-id="element-7237">
              <Star size={20} className="text-pink-500" data-id="element-7238" />
              Celebrity AI Angels
            </h2>
            <div className="relative" data-id="element-7239">
              <input type="text" placeholder="Search angels..." className="pl-8 pr-3 py-1.5 bg-gray-100 dark:bg-gray-800 dark:border dark:border-gray-700 rounded-full text-sm dark:text-gray-300 dark:placeholder-gray-500" data-id="element-7240" />
              <Search size={14} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-7241" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-7242">
            {celebrityAngels.map(angel => <div key={angel.id} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm dark:shadow-gray-900/10" data-id="element-7243">
                <div className="relative" data-id="element-7244">
                  <img src={angel.image} alt={angel.name} className="w-full h-48 object-cover" data-id="element-7245" />
                  <div className="absolute top-2 right-2" data-id="element-7246">
                    {renderTierBadge(angel.tier)}
                  </div>
                  {angel.limitedTime && <div className="absolute top-2 left-2 px-2 py-0.5 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full text-xs font-medium" data-id="element-7247">
                      Limited Time
                    </div>}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-3" data-id="element-7248">
                    <h3 className="font-bold text-white" data-id="element-7249">{angel.name}</h3>
                    <p className="text-xs text-gray-200" data-id="element-7250">{angel.niche}</p>
                  </div>
                </div>
                <div className="p-3" data-id="element-7251">
                  <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-2 mb-3" data-id="element-7252">
                    <p className="text-sm text-of-text-secondary dark:text-gray-300 italic" data-id="element-7253">
                      "{angel.quote}"
                    </p>
                  </div>
                  <div className="space-y-1 mb-3" data-id="element-7254">
                    {angel.benefits.map((benefit, index) => <div key={index} className="flex items-center gap-1.5" data-id="element-7255">
                        <Check size={12} className="text-green-500" data-id="element-7256" />
                        <span className="text-xs text-of-text-secondary dark:text-gray-400" data-id="element-7257">
                          {benefit}
                        </span>
                      </div>)}
                  </div>
                  <button className="w-full py-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-md text-white text-sm font-medium" onClick={() => navigateToAngel(angel.route)} data-id="element-7258">
                    {angel.cta}
                  </button>
                  <div className="mt-2 text-center" data-id="element-7259">
                    <button className="text-xs text-of-blue dark:text-pink-400" data-id="element-7260">
                      Try Free Message
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="p-4 bg-gradient-to-r from-yellow-50 to-amber-50 dark:from-yellow-900/20 dark:to-amber-900/20 rounded-lg border border-yellow-100 dark:border-yellow-800/30" data-id="element-7261">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-7262">
              <div className="flex-1" data-id="element-7263">
                <h3 className="text-lg font-bold text-of-text-primary dark:text-white flex items-center gap-2" data-id="element-7264">
                  <Crown size={20} className="text-yellow-500" data-id="element-7265" />
                  VIP Access Unlocks All Celebrity Angels
                </h3>
                <p className="text-sm text-of-text-secondary dark:text-gray-400 mt-1" data-id="element-7266">
                  Upgrade to Devoted VIP to get full access to all Celebrity AI
                  Angels including exclusive content, private 1-on-1 sessions,
                  and early access to new releases.
                </p>
              </div>
              <button className="px-6 py-2.5 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-full text-white font-medium" data-id="element-7267">
                Go VIP Now
              </button>
            </div>
          </div>
        </div>}

      {activeTab === 'benefits' && <div className="space-y-6" data-id="element-7268">
          <h2 className="text-lg font-bold text-of-text-primary dark:text-white" data-id="element-7269">
            FanClub Benefits Overview
          </h2>
          <div className="overflow-x-auto" data-id="element-7270">
            <table className="w-full border-collapse" data-id="element-7271">
              <thead data-id="element-7272">
                <tr data-id="element-7273">
                  <th className="py-3 px-4 text-left text-of-text-primary dark:text-white" data-id="element-7274">
                    Feature
                  </th>
                  <th className="py-3 px-4 text-center text-of-text-primary dark:text-white" data-id="element-7275">
                    <div className="flex flex-col items-center" data-id="element-7276">
                      <Heart size={16} className="text-amber-500" data-id="element-7277" />
                      <span data-id="element-7278">Lover</span>
                      <span className="text-xs text-of-text-secondary dark:text-gray-400" data-id="element-7279">
                        $9.99/mo
                      </span>
                    </div>
                  </th>
                  <th className="py-3 px-4 text-center text-of-text-primary dark:text-white" data-id="element-7280">
                    <div className="flex flex-col items-center" data-id="element-7281">
                      <Key size={16} className="text-gray-500 dark:text-gray-400" data-id="element-7282" />
                      <span data-id="element-7283">Heartkeeper</span>
                      <span className="text-xs text-of-text-secondary dark:text-gray-400" data-id="element-7284">
                        $24.99/mo
                      </span>
                    </div>
                  </th>
                  <th className="py-3 px-4 text-center text-of-text-primary dark:text-white" data-id="element-7285">
                    <div className="flex flex-col items-center" data-id="element-7286">
                      <Crown size={16} className="text-yellow-500" data-id="element-7287" />
                      <span data-id="element-7288">Devoted VIP</span>
                      <span className="text-xs text-of-text-secondary dark:text-gray-400" data-id="element-7289">
                        $49.99/mo
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-7290">
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7291">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7292">
                    Profile Badge
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7293">
                    Lover Badge
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7294">
                    Silver Badge
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7295">
                    Gold Crown
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7296">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7297">
                    Intimacy XP Boost
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7298">
                    +25%
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7299">
                    +50%
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7300">
                    +100%
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7301">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7302">
                    Celebrity AI Access
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7303">
                    2 Angels
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7304">
                    5 Angels
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7305">
                    All Angels
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7306">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7307">
                    ToySync Features
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7308">
                    Basic
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7309">
                    Unlimited
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7310">
                    Full Control
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7311">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7312">
                    1-on-1 AI Sessions
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7313">
                    -
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7314">
                    Limited
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7315">
                    Unlimited
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7316">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7317">
                    VR Content
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7318">
                    -
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7319">
                    Basic
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7320">
                    Premium
                  </td>
                </tr>
                <tr className="border-t border-gray-200 dark:border-gray-700" data-id="element-7321">
                  <td className="py-3 px-4 text-of-text-primary dark:text-gray-300" data-id="element-7322">
                    Content Drops
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7323">
                    Monthly
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7324">
                    Weekly
                  </td>
                  <td className="py-3 px-4 text-center text-of-text-secondary dark:text-gray-400" data-id="element-7325">
                    Daily
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="flex justify-center gap-4 mt-6" data-id="element-7326">
            <button className="px-6 py-2.5 bg-amber-500 rounded-md text-white font-medium" data-id="element-7327">
              Join Lover
            </button>
            <button className="px-6 py-2.5 bg-gray-500 rounded-md text-white font-medium" data-id="element-7328">
              Join Heartkeeper
            </button>
            <button className="px-6 py-2.5 bg-yellow-500 rounded-md text-white font-medium" data-id="element-7329">
              Go VIP
            </button>
          </div>
        </div>}

      <style jsx data-id="element-7330">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>;
};